
import Vue from 'vue';

import scrollreveal from 'scrollreveal';

var Reveal = scrollreveal({
  duration: 1500,
  delay: 240,
  scale: 1,
  distance: '40px',
  origin: 'bottom',
  easing: 'ease',
  viewFactor: 0.2,
  reset: false,
  mobile: false,

  beforeReveal: function beforeReveal(el) {
    //el.classList.remove('reveal-target')
    el.style.visibilty = 'visible';
  },

  afterReveal: function afterReveal(el) {
    setTimeout(function () {
      el.style.transform = 'none';
    }, 500);
  }
});

Vue.directive('scroll-reveal', {
  bind: function bind(el) {
    //el.classList.add('reveal-target')
    el.style.visibilty = 'hidden';
  },
  inserted: function inserted(el, _ref) {
    var value = _ref.value;

    Reveal.reveal(el, value);
  },
  update: function update() {
    Reveal.sync();
  }
});


//////////////////
// WEBPACK FOOTER
// ./directives/scroll-reveal.js
// module id = ./directives/scroll-reveal.js
// module chunks = 5